<template>
  <div>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
        <!-- <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a> -->
      </v-col>
      <v-col md="8" sm=12 style="background-color: #FFFFFF; position: relative;" class="">
        <v-row class="overflow-hidden" style="" justify="center">
          <v-col cols="12" class="font-weight-black mt-16">
            <v-row class="mt-16" style="color: black; font-size: 24px; text-decoration:none;" justify="center">運営会社</v-row>
          </v-col>
          <v-col cols="12">
            <v-simple-table class="">
              <tbody>
                <tr class="text-left">
                  <td class="font-weight-black">会社名</td>
                  <td class="">株式会社Respawn</td>
                </tr>
                <tr class="text-left">
                  <td class="font-weight-black">代表者</td>
                  <td class="">代表取締役 芳井 清彦</td>
                </tr>
                <tr class="text-left">
                  <td class="font-weight-black">所在地</td>
                  <td class="">〒154-0012<br/>東京都世田谷区駒沢5-26-7<br/>駒沢パークサイドテラス ノース3F</td>
                </tr>
                <tr class="text-left">
                  <td class="font-weight-black">許可番号</td>
                  <td class="">有料職業紹介事業許可番号「13-ユ-310095」</td>
                </tr>
                <tr class="text-left">
                  <td class="font-weight-black">設立</td>
                  <td class="">2016年3月29日</td>
                </tr>
                <tr class="text-left">
                  <td class="font-weight-black">資本金</td>
                  <td class="">2,000万円</td>
                </tr>
                <tr class="text-left">
                  <td class="font-weight-black">URL</td>
                  <td class=""><a class="" style="color: black;" href='https://respawn.jp/' target="_blank">https://respawn.jp/</a></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'Company',
  data() {
    return {
      inquiry: {
        company: '',
        inquiry_type: '',
        inquiry_contents: '',
      },
      user: {
        name: '',
        email: '',
        user_id: '',
      },
      inquiry_image: '',
      imageUrl: '',
      loading: false,
      isFinished: false,
    };
  },
};
</script>
